import React, { useEffect, useState } from 'react';

const DelayedLoadingFallback = () => {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => setShowLoading(true), 1000);
    return () => window.clearTimeout(timeoutId);
  }, []);

  if (!showLoading) {
    return null;
  }

  return (
    <div className="pt-3 text-center">
      <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
  );
};

export default DelayedLoadingFallback;